<div class="notifications" [ngClass]="{'submenu-open': isSubmenuOpen}">
  <div
    class="relative"
    [ngClass]="{'mt-[6px]': !isMobile}"
    (click)="toggleSubmenu()"
    (keyup)="onKeyUp($event, 'submenu')"
    tabindex="-1"
  >
    <span
      class="block w-[32px] h-[32px] bg-black dark:bg-white"
      style="
        -webkit-mask: url(&quot;/assets/images/icons/bell.svg&quot;);
        mask: url(&quot;/assets/images/icons/bell.svg&quot;);
        -webkit-mask-size: 32px 32px;
        mask-size: 32px 32px;
      "
    ></span>
    @if (unreadNotifications?.length! > 0) {
    <div
      class="notification-count-badge notification-count-badge--floating color"
    >
      {{ unreadNotifications?.length || 0 }}
    </div>
    }
  </div>

  @if (!isMobile) {
  <div
    class="notifications__submenu border border-borders-light dark:border-borders-darker shadow-2xl dark:shadow-blackest/60"
  >
    <app-notifications-list
      [isMobile]="isMobile"
      [user]="user"
      [isOpened]="isSubmenuOpen"
    ></app-notifications-list>
  </div>
  }
</div>

@if (!isMobile) {
<app-modal
  [modalId]="'dlt_notifications'"
  class="z-[110]"
  classes="!h-[220px] max-w-[560px]"
>
  <h2 class="text-center">
    {{ "DELETE_NOTIFICATIONS" | translate }}
  </h2>
  <div
    class="mt-5 flex justify-end items-center uppercase font-bold cursor-pointer text-[16px]"
  >
    <button
      (click)="closeModal('dlt_notifications')"
      (keyup)="onKeyUp($event, 'closeModal', 'dlt_notifications')"
      tabindex="0"
      class="uppercase"
    >
      {{ "NO_MY_BAD" | translate }}
    </button>
    <button
      (click)="deleteNotifications()"
      (keyup)="onKeyUp($event, 'deleteNotifications')"
      tabindex="0"
      class="ml-2 text-primary-text uppercase"
    >
      {{ "YES_PLEASE" | translate }}
    </button>
  </div>
</app-modal>
}
